import React, {PropsWithChildren, useContext} from "react";
import {ServerDataContext} from "./ServerDataContext";
import {Job} from "../models/job.model";

export const JobContext = React.createContext({} as Job);

export const JobProvider: React.FunctionComponent<PropsWithChildren> = ({children}) => {
    const data = useContext(ServerDataContext);

    return (
        <JobContext.Provider value={data.job}>
            {children}
        </JobContext.Provider>
    )
}